/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import _ from "lodash";
import BankAccount from "./BankAccount/BankAccount";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import { formValue } from "../../../services/formServiceFunctions";
import MenuItem from "@mui/material/MenuItem";
import { Box, SelectChangeEvent } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const BankAccounts = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasBankAccount: pcs.hasBankAccount,
    bankAccounts: pcs.bankAccounts,
  };

  const { values, handleChange, handleSubmit, registerValidators, errors, touchedValues, handleBlur } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const add = () => {
    const empty = {
      type: "",
      owner: "",
      name: "",
      amount: "",
    };

    const bankAccounts = values.bankAccounts || [];
    if (bankAccounts.length >= 3) {
      return;
    }

    bankAccounts.push(empty);

    handleChange({
      target: {
        type: "other",
        name: "bankAccounts",
        value: bankAccounts,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      add();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);
      handleChange({
        target: {
          type: "other",
          name: "bankAccounts",
          value: _.slice(values.bankAccounts, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Konten</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid size={12}>
            <Grid sx={processCostSupportStyle.question} size={12}>
              Haben Sie Bank- , Giro- oder Sparkonten (auch Gemeinschaftskonten)? Angaben zu Ihren Konten sind Pflicht
              für die Bewilligung von Verfahrenskostenhilfe.
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
                lg: 4
              }}>
              <ValidatorSelect
                label={"Konto"}
                name={"hasBankAccount"}
                value={formValue(values, "hasBankAccount")}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <MenuItem value={"no"}>Nein</MenuItem>
                <MenuItem value={"yes"}>Ja</MenuItem>
              </ValidatorSelect>
            </Grid>
          </Grid>
          {formValue(values, "hasBankAccount") === "yes" && (
            <>
              {_.map(values.bankAccounts, (bankAccount, key) => (
                <React.Fragment key={key}>
                  <BankAccount
                    path={`bankAccounts[${key}]`}
                    account={bankAccount}
                    handleChange={handleChange}
                    registerValidators={registerValidators}
                    errors={errors}
                  />
                  {parseInt(key) < 2 && (
                    <>
                      <Grid sx={processCostSupportStyle.question} size={12}>
                        Haben Sie ein weiteres Konto?
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 6,
                          lg: 4
                        }}>
                        <ValidatorSelect
                          label={"Weiteres Konto"}
                          name={`hasMore-${key}`}
                          value={formValue(values, "bankAccounts").length - 1 > parseInt(key) ? "yes" : "no"}
                          onChange={handleMore}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={"no"}>Nein</MenuItem>
                          <MenuItem value={"yes"}>Ja</MenuItem>
                        </ValidatorSelect>
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default BankAccounts;
